<div class="absolute bg-krstic w-full h-[50px]"></div>
<app-navbar></app-navbar>
<div class="overflow-hidden z-0 bg-dewLL h-[calc(100dvh-50px-13vh)] border-b-4 border-krstic flex flex-col md:flex-row justify-end relative">
  <div class="top-0 absolute w-full h-[calc(100dvh-50px-13vh)] header z-10"></div>
  <div class="top-0 absolute w-full h-[calc(100dvh-50px-13vh)] headerLayer z-10"></div>
  <div class="basis-1/2 flex flex-col justify-end p-8 text-krstic z-50">
    <div class="flex justify-end">
      <p class="text-6xl font-bold bg-krsticWhite w-fit p-2">DEV</p>
    </div>
    <div class="flex justify-end">
      <p class="text-xl p-2 bg-krsticWhite w-fit">Collection of solo projects and team projects from competitions.<br> Main focus on frontend web development.</p>
    </div>
  </div>
</div>
<div class="bg-krstic h-[13vh] text-krsticWhite text-4xl md:text-6xl text-center p-8 flex flex-col justify-center"><p class="mb-0">PROJECTS</p></div>
<div class=" fullpage mx-0 pr-0 titleWdesc flex flex-col">
  <div class="projectsContainer flex flex-col flex-wrap lg:flex-row overflow-hidden" *ngFor=" let project of allprojects">
    <div class="lg:basis-1/2 min-h-[35vh] lg:w-1/2 flex flex-col justify-between select-none">
        <div class="flex flex-col w-full basis-2/5">
          <div class="w-full hook bg-bitterRed text-[#f6f6f6] flex justify-center">
            <div class="flex flex-col justify-center w-full">
              <div class="flex justify-evenly flex-row w-full h-full">
                <a class="basis-auto w-full h-full" [href]="project.gitlink"><div  class="basis-auto p-3 w-full h-full actionBtn bg-[#212121] flex flex-col justify-center text-center">
                  <h5 class="mb-0">GITHUB</h5>
                </div></a>
                <a class="basis-auto w-full h-full" *ngIf="project.liveLink.length > 0" [href]="project.liveLink"><div class="basis-auto p-3 w-full h-full actionBtn bg-[#212121] flex flex-col justify-center text-center">
                  <h5 class="mb-0">WEBSITE</h5>
                </div></a>
              </div>
            </div>
          </div>

          <div class="flex w-full justify-end tech mr-4 mt-1 mb-8">
            <p *ngIf="project.development" class="animate-pulse border-2 border-dew text-krstic bg-dew rounded-full font-bold px-2 py-1 m-2 h-fit">IN DEVELOPMENT</p>
            <div class="flex">
              <p class="border-2 border-dew text-dew rounded-full px-2 py-1 m-2 h-fit" *ngFor=" let technology of project.technologies">
              {{technology}}
              </p>
            </div>
          </div>

        </div>
      <div class="basis-3/5 flex flex-col justify-end mt-8">
        <div class="text-dew text-5xl lg:text-8xl relative">
          <h5 class="px-2 mb-0">{{project.date}}</h5>
          <p class="px-2 mb-0 leading-[0.75] font-bold inline-block align-bottom">{{project.name.toLocaleUpperCase()}}</p>
        </div>
        <div class="text-dewLL text-sm">
          <p class="px-2">{{project.desc}}</p>
        </div>
      </div>
    </div>
    <video class="bg-krstic md:basis-1/2 lg:w-1/2 h-auto shrink-0" autoplay loop [src]="project.img"></video>
  </div>
</div>
<app-footer></app-footer>
